<template>
  <section class="page-container grid-container" v-if="loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1 class="text-2xl font-bold">Internal Milestone - {{ milestoneDefinition?.displayName }}</h1>
                    <p>Please mark this milestone as complete once the internal taks has been carried out.</p>
                    <br/>
                    <button class="btn btn-primary" @click="markTaskAsComplete">Mark as Complete</button>
                    <button class="btn btn-secondary" @click="router.back()">Return to Dashboard</button>
                </div>
            </div>
        </section>


</div>


  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {  getMilestoneDefinition} from '@/helpers/milestones/milestone.js'

import { useProjectStore } from '@/stores/project.js'
const project = useProjectStore();


const router  = useRouter()
const route = useRoute();
const loaded = ref(true);


const milestoneId = route.params.milestoneId;

const milestoneRecord = ref(null);
const milestoneDefinition = ref(null);
const error = ref(false);


import { getMilestone, putMilestone} from '@/services/implementationmanagement.api';


const errorString = ref('An error has occurred. Please contact your Qtac account manager.');

const markTaskAsComplete = async () => {
    
    try {

        milestoneRecord.value.status = 'SuccessfullyCompleted';
        milestoneRecord.value.completed = new Date().toISOString();

        var response = await putMilestone(milestoneId, milestoneRecord.value);


        if(response.status !== 200) {
            error.value = 'Error saving data. Please contact your Qtac account manager.';
            return false;
        }   
        
        var statefulMilestone = project.milestones.find(m => m.milestoneId === milestoneId);

        if(statefulMilestone) {
          statefulMilestone.status = milestoneRecord.value.status;
          statefulMilestone.completed = milestoneRecord.value.completed;    
        }

        router.push('/');

    } catch (e) {
        error.value = true;
    }
};

onMounted(async () => {

    try {
        var milestone = await getMilestone(milestoneId);
        milestoneRecord.value = milestone.data;
        if(milestoneRecord.value == null) {
            error.value = 'errorString';
            return;
        }

        milestoneDefinition.value = getMilestoneDefinition(milestoneRecord.value.type)




    } catch (err) {
        error.value = errorString;
        console.error(err);
    }

loaded.value = true;
})

</script>

